import { gql } from '@apollo/client';

const QUERY = gql`
  query ShowOrder($orderNumber: ID!) {
    showOrder(orderNumber: $orderNumber) {
      id
      orderNumber
      status
      customerEmail
      amount
      amountPaid
      amountRemaining
      amountRefunded
      lineItems {
        id
        participantName
        participantGroupName
        description
        type
        externalType
        amount
        canceled
      }
    }
  }
`;

export default QUERY;
